import type { AuthMe, AuthSession } from '@ldembalagens/types';
import { api, apiFetch } from '@/lib/api-client';
import { authStore } from '@/stores/auth-store';

export interface LoginInput {
  email: string;
  password: string;
  tenantId?: string;
}

export async function login(input: LoginInput): Promise<AuthSession> {
  const session = await apiFetch<AuthSession>('/auth/login', {
    method: 'POST',
    body: input,
    skipAuthRefresh: true,
  });
  authStore.getState().setSession(session);
  return session;
}

export async function logout(): Promise<void> {
  try {
    await apiFetch<void>('/auth/logout', { method: 'POST', skipAuthRefresh: true });
  } finally {
    authStore.getState().clear();
  }
}

export async function switchTenant(tenantId: string): Promise<AuthSession> {
  const session = await api.post<AuthSession>('/auth/switch-tenant', { tenantId });
  authStore.getState().setSession(session);
  return session;
}

export function fetchMe(): Promise<AuthMe> {
  return api.get<AuthMe>('/auth/me');
}

export function changePassword(input: {
  currentPassword: string;
  newPassword: string;
}): Promise<void> {
  return api.patch<void>('/auth/me/password', input);
}
